<template>
  <div class="tpl-editor-area-layout" draggable="false">
    <div
      class="tpl-editor-area"
      :style="getStyle"
      :class="editorClass"
      draggable="false"
    >
      <div class="scale-box" :style="getScaleStyle" draggable="false">
        <!--点击某元素时，元素放入新dom中并置顶且z-index=1000，当操作结束隐藏新dom-->
        <draggable-resize
          :key="refreshKey"
          class-name-dragging="img-dragging"
          class-name-resizing="img-resizing"
          @resizing="onResizing"
          @resizestop="onResizstop"
          @dragstop="onDragstop"
          @dragging="onDragging"
          class="resize-dom"
          :scale-ratio="scale"
          :active="true"
          :minWidth="10"
          :minHeight="12"
          :prevent-deactivation="true"
          :w="+clickItem.width"
          :h="+clickItem.height"
          :x="+clickItem.left"
          :y="+clickItem.top"
          v-if="dragVisible"
        >
          <div @dblclick="onDragClick" class="tpl-drag-cover"></div>
          <!--<self-option ref="currentSelfOptionRef" :style="getDragOptionStyle" :edit="false" :item="clickItem"-->
          <!--@onTextBlur="onEditTextBlur" :layerResize="true"></self-option>-->
        </draggable-resize>
        <div
          class="text-editable-border"
          :style="calcTextEditableStyle"
          v-if="textEditable"
        ></div>
        <!--<div class="attr-img-cover" v-if="clickItem && clickItem.width > 0 && layerResize" :style="itemCoverStyle"></div>-->
        <div v-if="disabled" class="disabled-cover"></div>
        <self-option-list
          class="tpl-editor-area-overflow"
          :key="editorObj.key"
          :enterKeydownFunc="keydown"
          :dragMoving="dragMoving"
          :layerResize="layerResize"
          :addItemFunc="addItemFunc"
          :children="editorObj.children"
          :parent="editorObj"
          :editorObj="editorObj"
          :edit="edit"
          :moduleCover="moduleCover"
          :rootScale="rootScale"
          @onOpenGroupDialog="onOpenGroupDialog"
          @onOptionListClick="onOptionListClick"
          @onMaterialImgClick="onMaterialImgClick"
          @onTextBlur="onTextBlur"
          @onTextFocus="onTextFocus"
          @onItemClick="onItemClick"
          @onCssTextClick="onCssTextClick"
          @onTextHover="onTextHover"
          @addCache="addCache"
          @onCutImg="onCutImg"
          @onTableClick="onTableClick"
          v-if="editorObj.children && editorObj.children.length > 0"
        ></self-option-list>
        <!--<div class="text-hover-tip" :style="textHoverStyle" v-if="edit && !dragMoving">-->
        <!--单击修改文字-->
        <!--</div>-->
      </div>
    </div>
    <div class="drag-move" draggable="false" :style="dragBarStyle" v-if="edit">
      <span class="drag-move-bar" :style="dragBarCursorStyle"></span
      ><span class="drag-height" v-show="dragMoving" :style="dragHeightStyle">{{
        editorObj.height
      }}</span>
      <span
        class="move-tip text-hover-tip"
        :style="moveHoverStyle"
        v-show="!dragMoving"
        >拖动调整画布⾼度</span
      >
    </div>
  </div>
</template>
<script>
import { empty_template_group, minus_plus } from '../../../const.js'
import selfOptionList from './self-option-list'
import util from '../../../util.js'
import TUtil from '../TUtil'
import draggableResize from '../../components/draggable-resize/draggable-resizable'
const empty_item = { left: 0, top: 0, width: 0, height: 0 }
export default {
  components: { selfOptionList, draggableResize },
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    tplType: String,
    rootScale: {
      type: Number,
      default: 1
    },
    scale: {
      type: [Number, String],
      default: 1
    },
    edit: {
      type: Boolean,
      default: true
    },
    dragMoving: {
      type: Boolean,
      default: false
    },
    moduleCover: {
      // 模块组 选中模板时遮盖层
      type: Boolean,
      default: false
    },
    itemCover: {
      // 属性面板，选中元素遮盖层
      type: Object,
      default: null
    },
    layerResize: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tplProjectId: String
  },
  data () {
    return {
      addItemFunc: (children, idx, height, minusOrPlus) => {
        this.onAddItem(children, idx, height, minusOrPlus)
      },
      keydown: (item, minusOrPlus, height) => {
        this.onKeydown(item, minusOrPlus, height)
      },
      editorObj: JSON.parse(JSON.stringify(empty_template_group)).json,
      activeIndex: {},
      inputEnd: true,
      showEditorOperation: true,
      hoverItem: null,
      clickItem: Object.assign({}, empty_item),
      refreshKey: 0,
      showLayer: false, // 显示所有图层边框，用来查看图层是否存在覆盖，导致无法点击
      textEditable: false
    }
  },
  computed: {
    editorClass () {
      let arr = []
      if (this.dragMoving) {
        arr.push('editor-drag-moving')
      }
      if (this.edit) {
        arr.push('tpl-edit')
      }
      if (this.showLayer) {
        arr.push('tpl-layer-view')
      }
      if (this.layerResize) {
        arr.push('tpl-panel')
      }
      return arr.join(' ')
    },
    dragHeightStyle () {
      let fontSize = parseInt(14 / this.rootScale)
      return `font-size:${fontSize}px`
    },
    getStyle () {
      let item = this.editorObj
      let w = +item.width * this.scale
      let h = +item.height * this.scale
      return `width: ${w}px;height:${h}px;background-color:${item.backgroundColor}`
    },
    getScaleStyle () {
      let item = this.editorObj
      return `transform:scale(${this.scale});width: ${item.width}px;height:${item.height}px`
    },
    getDragOptionStyle () {
      let item = this.clickItem
      if (['vertical-lr', 'vertical-rl'].indexOf(item.writingMode) > -1) {
        return `writing-mode: ${item.writingMode}`
      } else {
        return null
      }
    },
    selectedItemForModuleGroup () {
      return this.$store.state.templateGroup.selectedItemForModuleGroup
    },
    coverStyleForModuleGroup () {
      let { item, parent } = this.selectedItemForModuleGroup
      if (item) {
        // 扩大选中的背景边框
        let addVal = 10
        // let width = parseFloat(item.width) + addVal;
        let height = parseFloat(item.height) + addVal
        let top = parseFloat(item.top) - +parent.top
        // let left = parseFloat(item.left) - (+parent.left);
        return `z-index: ${200};left: 0px;top: ${top}px;width:100%;height:${height}px;pointer-events: initial`
      }
      return 'display:none'
    },
    dragBarStyle () {
      let h = parseInt(15 / this.rootScale)
      return `height: ${h}px`
    },
    dragBarCursorStyle () {
      let h = parseInt(6 / this.rootScale),
        w = parseInt(50 / this.rootScale)
      return `height: ${h}px;width: ${w}px`
    },
    moveHoverStyle () {
      let height = parseInt(32 / this.rootScale)
      let fontSize = parseInt(14 / this.rootScale)
      return `font-size:${fontSize}px;margin-top:${
        -height - 15
      }px;height:${height}px;line-height:${height}px;`
    },
    dragVisible () {
      let clickItem = this.clickItem
      let isEmpty =
        clickItem.width === 0 &&
        clickItem.height === 0 &&
        clickItem.left === 0 &&
        clickItem.top === 0
      return (
        this.layerResize &&
        !isEmpty &&
        !clickItem.isPageBgImg &&
        !this.textEditable
      )
    },
    isText () {
      return 'text' === this.clickItem.type
    },
    itemCoverStyle () {
      let itemCover = this.clickItem
      return {
        width: `${itemCover.width}px`,
        height: `${itemCover.height}px`,
        left: `${itemCover.left}px`,
        top: `${itemCover.top}px`
      }
    },
    calcTextEditableStyle () {
      let scale = 1
      let { width, height, top, left, rotate } = this.clickItem
      return `transform: rotateZ(${rotate || 0}deg);width: ${
        width * scale
      }px;height:${height * scale}px;left:${left * scale}px;top:${
        top * scale
      }px`
    }
  },
  watch: {
    value: {
      handler () {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    if (this.edit) {
      document.addEventListener('keyup', this.onWinKeyup)
      document.addEventListener('keydown', this.onWinKeydown)
    }
    if (this.layerResize) {
      this.eventBus.$on('_triggerClearItem', this._triggerClearItem)
    }
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.onWinKeyup)
    document.removeEventListener('keydown', this.onWinKeydown)
    if (this.layerResize) {
      this.eventBus.$off('_triggerClearItem', this._triggerClearItem)
    }
  },
  methods: {
    init () {
      Object.assign(this.editorObj, this.value)
			// console.log('editorObj', JSON.parse(JSON.stringify(this.editorObj)), JSON.parse(JSON.stringify(this.value)), JSON.parse(JSON.stringify(this.editorObj)))
      if (this.tplProjectId) {
        this.loadingFont()
      }
    },
    onWinKeyup (ev) {
      if (!this.disabled && !ev.shiftKey && this.showLayer) {
        this.showLayer = false
      }
      if (ev.code === 'Tab') {
        // tab切换时，激活当前选中图片，触发click事件
        util.runDelay(500, () => {
          let acDom = document.activeElement
          if (
            acDom &&
            acDom.className &&
            acDom.className.indexOf('img-parent-box') > -1
          ) {
            acDom.click()
          }
        })
      }
    },
    onWinKeydown (ev) {
      if (!this.disabled && ev.shiftKey && !this.showLayer) {
        this.showLayer = true
      }
    },
    async loadingFont (fontList) {
      let fontNameSet = new Set()
      let dataList = [],
        fontF
      util.deepChildren(this.editorObj.children, dataList)
      dataList.forEach(item => {
        if (item.fontFamily) {
          let ffList = item.fontFamily.split(',')
          ffList.forEach(ff => {
            fontF = ff.trim()
            if (fontF) {
              fontNameSet.add(fontF)
            }
          })
        }
      })
      util.appendFontStyle(this.tplProjectId, [...fontNameSet])
    },
    getFontUrl (fontFamily) {
      let fontList = this.$store.state.app.projectFontList
      let fontUrl = fontList.filter(item => {
        return item.name === fontFamily
      })[0].url
      return fontUrl
    },
    setTextHeight (item, minusOrPlus, height) {
      height = minusOrPlus === minus_plus.minus ? -height : height
      item.height = +item.height + height
      item.right = +item.right + height
    },
    onKeydown (item, minusOrPlus, height) {
      if (this.layerResize) {
        //模板配置页，当前文本编辑，不影响其它图层
        this.setTextHeight(item, minusOrPlus, height)
        return
      }
      if (minusOrPlus && height) {
        this.addCache()
        let editorObj = this.editorObj
        TUtil.moveItem(editorObj, item, minusOrPlus, height)
        this.$emit('onKeydown', minusOrPlus, height)
      }
    },
    onOpenGroupDialog (item) {
      this.$emit('onOpenGroupDialog', item)
    },
    onOptionListClick (item) {
      this.$emit('onOptionListClick', item)
    },
    onMaterialImgClick (item, ev) {
      this.$emit('onMaterialImgClick', item, ev)
    },
    onTextFocus (item) {
      this.$emit('onTextFocus', item)
    },
    onTextBlur (ev, item) {
      this.textEditable = false
      this.$emit('onTextBlur', ev, item)
    },
    fixLeft (item, parent) {
      /**
       * 子元素的left值 ，应该比父元素的大
       * 上传时，left 处理有问题，针对旧数据，此处修复下
       */
      if (item.left - parent.left < 0) {
        item.left = parent.left
      }
    },
    _triggerClearItem () {
      this.clickItem = Object.assign({}, empty_item)
    },
    _triggerItemClick (item, parent, ev) {
      this.onItemClick(item, parent, ev)
    },
    onItemClick (item, parent, ev) {
      if (this.showLayer) {
        this.showLayer = false
      }
      if (this.layerResize) {
        if (parent) {
          this.fixLeft(item, parent)
          this.parent = parent
        }
        this.clickItem = item
        this.refreshKey = util.getUUID()
      }
      this.$emit('onItemClick', item, parent, ev)
    },
    onCssTextClick (item) {
      this.$emit('onCssTextClick', item)
    },
    onOperationModuleGroup (type) {
      this.$emit('onOperationModuleGroup', type)
    },
    onTextHover (item) {
      this.hoverItem = item
    },
    addCache () {
      this.$emit('addCache')
    },
    onCutImg (item) {
      this.$emit('onCutImg', item)
    },
    onEditTextBlur (ev, item) {
      item.height = ev.target.offsetHeight
      this.toggleDragBar(true)
    },
    onResizing (left, top, width, height) {
      requestAnimationFrame(() => {
        this.clickItem.width = width
        this.clickItem.height = height
        this.updatePosition(left, top, width, height)
      })
    },
    onDragging (left, top, width, height) {
      requestAnimationFrame(() => {
        this.updatePosition(left, top, width, height)
      })
    },
    onDragstop (left, top, width, height) {
      if (this.clickItem.type === 'img') {
        this._triggerClearItem()
      }
    },
    onResizstop (left, top, width, height) {
      if (this.clickItem.type === 'img') {
        this._triggerClearItem()
      }
    },
    updatePosition (left, top) {
      if (this.parent) {
        let topVal = this.parent.top - top
        let leftVal = this.parent.left - left
        if (topVal > 0) {
          this.parent.top = this.parent.top - topVal
        }
        if (leftVal > 0) {
          this.parent.left = this.parent.left - leftVal
        }
      }
      let item = this.clickItem
      item.left = left
      item.top = top
      item.bottom = +item.height + +item.top
      item.right = +item.width + +item.left
      item.pRight = this.editorObj.width - item.right
      this.parent.bottom = +this.parent.height + +this.parent.top
      this.parent.right = +this.parent.width + +this.parent.left

      item.originData = item.originData ? item.originData : {}
      item.originData.left = item.left
      item.originData.top = item.top
      item.originData.bottom = item.bottom
      item.originData.right = item.right
    },
    onTableClick (item) {
      this.$emit('onTableClick', item)
    },
    onDragClick () {
      this.textEditable = true
    }
  }
}
</script>
<style lang="scss">
@import 'tpl-editor-area-group';
</style>
